import React from 'react'
import { Ordering } from 'storfox-filter'

import { PURCHASE_ORDER_COLUMNS as tableColumns } from './PurchaseTable'

import { FILTER_NAME as name } from '../../constants/Purchase'

export const purchaseOrderingOptions = {
  name,
  tableColumns
}

function PurchaseOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default PurchaseOrderingForm
